export interface BankTransferInstructions {
  recipientName: string;
  iban: string;
  bankName: string;
  branch: string;
  accountNumber: string;
}

export const bankTransferInstructionsFromResponse = (
  responseData: any,
): BankTransferInstructions => ({
  recipientName: responseData.recipient_name,
  iban: responseData.iban,
  bankName: responseData.bank_name,
  branch: responseData.branch,
  accountNumber: responseData.account_number,
});
